<template>
    <div class="content">
        <div class="step">
            <div class="step-title">
                <div class="step-number">1</div>
                <div class="step-text">地图数据区域</div>
            </div>
            <div class="step-content">
                <div class="step3-text">仅支持如下图区域的地图数据，涵盖亚洲部分区域，经度1~55，纬度73~137。</div>
                <img class="img img2" src="@/assets/map/map6.png">
            </div>
        </div>
        <div class="step">
            <div class="step-title step-title2">
                <div class="step-number">2</div>
                <div class="step-text">地图数据下载</div>
            </div>
            <div class="step-content">
                <div class="step3-text">
                    地貌地图：仅包括街道和主要路网、水道、自然特征，不包括国际边界、行政边界，同时也不包括兴趣点如商店、餐厅、停车区、学校等信息。
                </div>
                <div class="box box2">
                    <div class="box2-title">【下载链接1】</div>
                    <div class="box2-content box1-last">百度网盘：
                        <div class="link">https://pan.baidu.com/s/1msgLC4x3FCeZXCYjLxHBlQ</div>
                        提取码：<span class="light">mrui</span>
                    </div>
                </div>
                <div class="box box2">
                    <div class="box2-title">【下载链接2】</div>
                    <div class="box2-content box1-last">阿里云盘：
                        <div class="link">https://www.alipan.com/s/NFgTS36dZaw</div>
                        提取码：<span class="light">0w2r</span><br/>
                        阿里云盘下载后双击<span class="bold">BD地图.exe</span>，解压文件到本地。
                    </div>
                </div>
            </div>
        </div>
        <div class="step">
            <div class="step-title step-title2">
                <div class="step-number">3</div>
                <div class="step-text">地图安装步骤</div>
            </div>
            <div class="step-content">
                <div class="step3-text">
                    1、下载地图数据后，将<span class="bold">BDM.zip</span>直接解压到电脑；<br/>
                    2、将手表通过USB线插入电脑中，并等待<span class="bold">手表磁盘</span>出现；<br/>
                    3、将<span class="bold">整个[BDM]</span>目录复制到手表USB磁盘的<span class="bold">目录1</span>中；<br/>
                    4、地图安装完成后，打开手表<span class="bold">地图功能</span>中进行查看。
                </div>
                <div class="box box2 box3">
                    <div class="box2-title">【注意】</div>
                    <div class="box2-content">1、 地图文件复制的<span class="bold">时间</span>可能<span
                            class="bold">比较长</span>，如果使用笔记本注意提前将电源适配器接上，并临时关闭休眠设置。
                    </div>
                    <div class="box2-content box1-last">2、[BDM]目录必须在目录1中，也<span
                            class="bold">不要</span>对[BDM]目录<span
                            class="bold">重新命名</span>。同时[BDM]目录下打开后为[1]、[2]、[3]...文件夹，也<span
                            class="bold">不要进行删除</span>或<span class="bold">重新命名</span>等操作。
                    </div>
                </div>
            </div>
        </div>
        <div class="step">
            <div class="step-title step-title2">
                <div class="step-number">4</div>
                <div class="step-text">其他声明</div>
            </div>
            <div class="other-box">
                <div class="other-title">
                    【©OpenStreetMap 条款和条件】
                </div>
                <div class="other-content box1-last">本地图使用社区生成的 ©OpenStreetMap (OSM) 数据库编译。本地图的使用不受最终用户许可协议
                    (EULA)条款的约束，而是受©OpenStreetMap以下条款和条件的约束：<br/>
                    ©OpenStreetMap 数据是 ©OpenStreetMap贡献者的版权，并受开放数据库许可的约束。<br/>©OpenStreetMap数据个别内容的任何权利均根据数据库内容许可获得许可。
                </div>
                <div class="other-title">
                    【风险提示】
                </div>
                <div class="other-content box1-last">
                    北斗卫星手表仅对 ©OpenStreetMap 地图做格式与样式转换，北斗卫星手表对 ©OpenStreetMap 产品中地图数据的准确性或完整性不作任何保证，您同意自行承担使用它的风险。<br/>
                    北斗卫星手表及其许可方的许可方、服务提供商、渠道合作伙伴和供应商以及附属公司，不作任何形式的、明示或暗示的、或其他方式的保证，包括但不仅限于从地图产品获得的内容、质量、准确性、完整性、有效性、可靠性、适销性、特定用途的适用性、有用性、用途或结果，或者内容或服务器不会中断或没有错误。<br/>
                    北斗卫星手表地图仅用做辅助工具，不得用于任何需要精确测量方向、距离、位置或地形。
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'instructions',
        data: {
            return: {
                active: 'a'
            }
        }
    }
</script>

<style scoped>

    .content {
        background-color: #FFFFFF;
        color: #000000;
        padding-top: 1px;
        width: 100%;
    }

    .box {
        width: 330px;
        margin-left: 30px;
        background: #F7F7F7;
        border-radius: 7px 7px 7px 7px;
        margin-bottom: 10px;
    }

    .box1-last {
        padding-bottom: 13px;
    }

    .step-title {
        width: 136px;
        height: 24px;
        background-color: #00BB7C;
        border-radius: 12px;
        margin-top: 19px;
        margin-left: 8px;
        position: relative;
    }

    .step-number {
        width: 20px;
        height: 20px;
        border-radius: 10px;
        background: #FFFFFF;
        position: absolute;
        left: 2px;
        top: 2px;
        color: #00BB7C;
        font-size: 18px;
        line-height: 20px;
        text-align: center;
    }

    .step-text {
        color: #FFFFFF;
        font-size: 15px;
        position: absolute;
        left: 32px;
        top: 5px;
        line-height: 14px
    }

    .step-content {
        border-left: 2px dashed #D2D2D2;
        width: 354px;
        margin-left: 20px;
        padding: 16px 0 6px 0;
    }

    .box2 {
        margin-left: 10px;
        font-size: 12px;
    }

    .link {
        color: #00BB7C;
        word-break: break-all;
        text-decoration: underline;
    }

    .light {
        color: #00BB7C;
        text-decoration: underline;
    }

    .box2-title {
        font-size: 12px;
        font-weight: bold;
        padding-left: 11px;
        padding-top: 13px;
        word-break: break-all;
    }

    .box2-content {
        font-size: 12px;
        padding-left: 18px;
        padding-top: 10px;
        line-height: 24px;
    }

    .step-title2 {
        margin-top: 0;
    }

    .bold {
        font-weight: bold;
    }

    .step2-text {
        font-size: 13px;
        width: 308px;
        margin-left: 28px;
        line-height: 23px;
        margin-bottom: 12px;
    }

    .box-sub-titel {
        margin-left: 30px;
        margin-top: 12px;
        font-size: 12px;
        font-weight: bold;
    }

    .box-sub-content {
        margin-left: 30px;
        margin-top: 8px;
        font-size: 12px;
        line-height: 24px;
        margin-right: 8px;
    }

    .error {
        width: 69px;
        height: 24px;
        border-radius: 11px 11px 11px 11px;
        opacity: 1;
        border: 1px solid #D91919;
        color: #D91919;
        text-align: center;
        line-height: 24px;
        margin-top: 15px;
        margin-left: 20px;
    }

    .error-sub {
        color: #D91919;
    }

    .yellow {
        color: #EAEA4C;
    }

    .img {
        width: 292px;
        margin-left: 30px;
        margin-top: 10px;
    }

    .prop {
        font-size: 13px;
        margin-left: 37px;
        margin-top: 17px;
        width: 308px;
        margin-bottom: 23px;
        line-height: 22px;
    }

    .step3-text {
        width: 300px;
        font-size: 13px;
        margin-left: 28px;
        line-height: 24px;
        margin-bottom: 12px;
    }

    .img2 {
        width: 166px;
        margin-left: 28px;
        margin-top: 0;
    }

    .other-box {
        margin-top: 13px;
        margin-left: 41px;
        margin-right: 19px;
    }

    .other-title {
        font-size: 13px;
        font-weight: bold;
    }

    .other-content {
        font-size: 13px;
        margin-left: 2px;
        line-height: 24px;
        margin-top: 6px;
    }

    .box3 {
        padding-right: 10px;
        width: 320px;
    }
</style>



// WEBPACK FOOTER //
// src/views/map/ta2000desc.vue